import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fragment } from 'react';
import { Col, Row } from 'react-bootstrap';
import DatePickerInput from '../../../components/DatePicker';
import Radio, { RadioGroup } from '../../../components/Radio';
import TextInput from '../../../components/TextInput';

export type StepProps = {
  data: any;
  collectStepData: (data: any) => void;
};

const RetirementInfoStep = ({ data, collectStepData }: StepProps) => {
  const handleRetirementDateChange = (date: Date) => {
    collectStepData({
      ...data,
      retirementDate: date,
    });
  };

  const handleBenefitsDateChange = (date: Date) => {
    collectStepData({
      ...data,
      benefitsStartDate: date,
    });
  };

  const handleElectionMethod = (e: string | number) => {
    collectStepData({
      ...data,
      electionMethod: e,
    });
  };

  const handleMartialStatus = (e: string | number) => {
    collectStepData({
      ...data,
      martialStatus: e,
    });
  };

  const handleMartialFirstName = (e: any) => {
    collectStepData({
      ...data,
      martialData: {
        ...data.martialData,
        firstName: e.target.value,
      },
    });
  };

  const handleMartialMiddleName = (e: any) => {
    collectStepData({
      ...data,
      martialData: {
        ...data.martialData,
        middleName: e.target.value,
      },
    });
  };

  const handleMartialLastName = (e: any) => {
    collectStepData({
      ...data,
      martialData: {
        ...data.martialData,
        lastName: e.target.value,
      },
    });
  };

  const handleMartialBirthDate = (e: any) => {
    collectStepData({
      ...data,
      martialData: {
        ...data.martialData,
        birthDate: e,
      },
    });
  };

  return (
    <Fragment>
      <Row className={'mt-11'}>
        <Col className={'col-12 col-lg-4 me-lg-13 pe-lg-7'}>
          <h3 className="mb-0 text-sm-20-lg-24 fw-light">
            {'Retirement information'}
          </h3>
          <DatePickerInput
            placeholder={'Select a date'}
            label={'When do you want to stop working?'}
            className="mt-7"
            onChange={(date) => handleRetirementDateChange(date)}
            minDate={new Date()}
            initialDate={data.retirementDate}
          />
          <DatePickerInput
            placeholder={'Select a date'}
            label={'When do you want to begin receiving pension benefits?'}
            className="mt-7"
            onChange={(date) => handleBenefitsDateChange(date)}
            minDate={new Date()}
            initialDate={data.benefitsStartDate}
          />
        </Col>
        <Col className={'col-12 col-lg-5 mt-11 mt-lg-0'}>
          <h3 className="mb-0 text-sm-20-lg-24 fw-light">
            {'Election Options'}
          </h3>
          <span className={'d-inline-block text-fs-6 mt-7 pt-1'}>
            {'How would you like to make your election?'}
          </span>
          <RadioGroup
            name={'election-method'}
            value={data.electionMethod}
            onChange={handleElectionMethod}
          >
            <Radio
              value={1}
              id={'eo-1'}
              label={'Continue my election online'}
              className={'mt-7'}
            />
            <Radio
              value={2}
              id={'eo-2'}
              label={'Have paper election package mailed to me via U.S.Mail'}
              className={'mt-7'}
            />
          </RadioGroup>
        </Col>
      </Row>
      <Row className={'mt-11 pt-lg-1'}>
        <Col className={'col-12 col-lg-4'}>
          <h3 className="mb-0 text-sm-20-lg-24 fw-light">{'Marital Status'}</h3>
          <RadioGroup
            name={'martial-status'}
            value={data.martialStatus}
            onChange={handleMartialStatus}
          >
            <Radio value={1} id={'ms-1'} label={'Single'} className={'mt-7'} />
            <div className="d-flex justify-content-between align-items-center">
              <Radio
                value={2}
                id={'ms-2'}
                label={'I am Married'}
                className={'mt-7'}
              />
              <div className="mt-7">
                <FontAwesomeIcon icon={light('chevron-down')} />
              </div>
            </div>
          </RadioGroup>
        </Col>
      </Row>
      {data.martialStatus === 2 && (
        <Row className={'mt-9'}>
          <Col className={'col-lg-4'}>
            <Col className={'col-12'}>
              <TextInput
                label={'Spouse’s first name'}
                onChange={handleMartialFirstName}
                value={data.martialData.firstName}
              />
            </Col>
            <Col className={'col-12 mt-7'}>
              <TextInput
                label={'Spouse’s middle name'}
                onChange={handleMartialMiddleName}
                value={data.martialData.middleName}
              />
            </Col>
            <Col className={'col-12 mt-7'}>
              <TextInput
                label={'Spouse’s last name'}
                onChange={handleMartialLastName}
                value={data.martialData.lastName}
              />
            </Col>
            <Col className={'col-12 mt-7'}>
              <DatePickerInput
                label={'Spouse’s birth date?'}
                onChange={handleMartialBirthDate}
                initialDate={data.martialData.birthDate}
              />
            </Col>
          </Col>
        </Row>
      )}
    </Fragment>
  );
};

export default RetirementInfoStep;
